import { useTranslations } from 'next-intl';
import type { PriceAlert } from '../types';
import { PriceAlertCard } from './PriceAlertCard';
import { PriceAlertRow } from './PriceAlertRow';

interface PriceAlertsTableProps {
  alerts: PriceAlert[];
  onEdit: (alert: PriceAlert) => void;
}

export function PriceAlertsTable({ alerts, onEdit }: PriceAlertsTableProps) {
  const t = useTranslations('priceAlerts.columns');

  return (
    <>
      {/* Mobile (<600px): card list */}
      <div className="flex flex-col gap-2 min-[600px]:hidden">
        {alerts.map((alert) => (
          <PriceAlertCard key={alert.id} alert={alert} onEdit={() => onEdit(alert)} />
        ))}
      </div>

      {/* Desktop (≥600px): grid table */}
      <div className="hidden grid-cols-[minmax(0,1fr)_auto_auto_auto_auto_auto] items-center gap-x-4 min-[600px]:grid">
        {/* Header */}
        <div className="col-span-full grid grid-cols-subgrid items-center gap-x-4 border-b border-v2-border px-2 pb-2">
          <span className="text-[10px] leading-none text-v2-text-secondary">{t('outcome')}</span>
          <span className="text-right text-[10px] leading-none text-v2-text-secondary">
            {t('target')}
          </span>
          <span className="text-right text-[10px] leading-none text-v2-text-secondary">
            {t('type')}
          </span>
          <span className="text-right text-[10px] leading-none text-v2-text-secondary">
            {t('lastSent')}
          </span>
          <span className="text-right text-[10px] leading-none text-v2-text-secondary">
            {t('status')}
          </span>
          <span aria-hidden />
        </div>

        {/* Rows */}
        {alerts.map((alert) => (
          <PriceAlertRow key={alert.id} alert={alert} onEdit={() => onEdit(alert)} />
        ))}
      </div>
    </>
  );
}
